<template>
  <div class="vx-col w-full">
    <vx-card title="Applicant Occupation Information (পেশাগত তথ্য)">
      <br>
      <form data-vv-scope="occupation">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Occupation Type (পেশার ধরণ)<sup>*</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio v-model="occupation.occupationType" vs-value="Employed" v-validate="'required'"
                              data-vv-as="Occupation Type" name="occupation.occupationType">Employed
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio v-model="occupation.occupationType" vs-value="Self-Employed" v-validate="'required'"
                              data-vv-as="Occupation Type" name="occupation.occupationType">Self-Employed
                    </vs-radio>
                  </li>
                  <li>
                    <vs-radio v-model="occupation.occupationType" vs-value="Unemployed" v-validate="'required'"
                              data-vv-as="Occupation Type" name="occupation.occupationType">Unemployed
                    </vs-radio>
                  </li>
                </ul>
                <span class="text-danger text-sm" v-show="errors.has('occupation.occupationType')">{{ errors.first('occupation.occupationType') }}</span>
              </div>
            </div>
          </div>
          <div v-if="occupation.occupationType !== 'Unemployed'" class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Organization Type (প্রতিষ্ঠানের ধরন)<sup>*</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <template>
                  <v-select label="occuName" v-model="occupation.occupationName" class="w-full select-large"
                            v-validate="'required'" data-vv-as="Organization Type" name="occupation.occupationName"
                            :options="occupationDrop" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                </template>
                <span class="text-danger text-sm" v-show="errors.has('occupation.occupationName')">{{ errors.first('occupation.occupationName') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Monthly Income in BDT (মাসিক আয়)<sup>*</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <v-select label="price_range" v-model="occupation.monthlyIncome" class="w-full select-large" v-validate="'required'" data-vv-as="Monthly Income" name="occupation.monthlyIncome"
                          :options="monthlyIncomeRange" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm" v-show="errors.has('occupation.monthlyIncome')">{{ errors.first('occupation.monthlyIncome') }}</span>
                <!--<vs-input class="w-full" type="text" @keypress="onlyNumber" v-model="occupation.monthlyIncome"
                          v-validate="'required'" data-vv-as="Monthly Income" name="occupation.monthlyIncome"/>
                <span class="text-danger text-sm" v-show="errors.has('occupation.monthlyIncome')">{{ errors.first('occupation.monthlyIncome') }}</span>-->
              </div>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Name of the Office/Business/Source of Income (অফিস/ব্যবসার নাম/আয়ের উৎস)<sup>*</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" type="text" v-model="occupation.officeOrBusinessNm" v-validate="'required'"
                          data-vv-as="Name of the Office/Business/Source of Income" name="occupation.officeOrBusinessNm"/>
                <span class="text-danger text-sm" v-show="errors.has('occupation.officeOrBusinessNm')">{{ errors.first('occupation.officeOrBusinessNm') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Designation (পদবি)<sup>*</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" type="text" v-model="occupation.designation" @keypress="isLetter"
                          v-validate="'required'" data-vv-as="Designation" name="occupation.designation"/>
                <span class="text-danger text-sm" v-show="errors.has('occupation.designation')">{{ errors.first('occupation.designation') }}</span>
              </div>
            </div>
          </div>
          <div v-if="occupation.occupationType !=='Unemployed' " class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Job length (চাকুরী/ব্যবসার বয়স)<sup>*</sup></span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div class="demo-alignment">
                  <vx-input-group class="mb-base">
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>Year</span>
                      </div>
                    </template>
                    <vs-input class="mt-0" type="text" @keypress="onlyNumber" v-model="occupation.year" placeholder="Year"
                              v-validate="'required'" data-vv-as="Year" name="occupation.year"/>
                  </vx-input-group>

                  <template>
                    <vx-input-group class="mb-base">
                      <template slot="prepend">
                        <div class="prepend-text bg-primary">
                          <span>Month</span>
                        </div>
                      </template>
                      <v-select v-model="occupation.month" class="select-large mt-0" style="width:120px"
                                placeholder="Months" :options="jobLengthArr" v-validate="'required'"
                                data-vv-as="Month" name="occupation.month"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                    </vx-input-group>
                  </template>
                </div>
                <span class="text-danger text-sm" v-show="errors.has('occupation.year')">{{ errors.first('occupation.year') }}</span>
                <span class="text-danger text-sm" v-show="errors.has('occupation.month')">{{ errors.first('occupation.month') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <vx-card title="Occupation Address">
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Division (বিভাগ)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <template>
                      <v-select label="name" v-model="occupation.occDivision" class="w-full select-large"
                                :options="divisionJson" v-validate="'required'" data-vv-as="Division"
                                name="occupation.occDivision"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    </template>
                    <span class="text-danger text-sm" v-show="errors.has('occupation.occDivision')">{{ errors.first('occupation.occDivision') }}</span>
                  </div>
                </div>
              </div>
              <div v-if="occupation.occDivision" class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>District(জেলা)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <template>
                      <v-select label="name" v-model="occupation.occDistrict" class="w-full select-large"
                                v-validate="'required'" data-vv-as="District" name="occupation.occDistrict"
                                :options="districtJson.filter(occuDist => occuDist.division_id === occupation.occDivision.id)"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    </template>
                    <span class="text-danger text-sm" v-show="errors.has('occupation.occDistrict')">{{ errors.first('occupation.occDistrict') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="occupation.occDistrict" class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Thana (থানা)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <template>
                      <v-select label="name" v-model="occupation.occThana" class="w-full select-large"
                                v-validate="'required'" data-vv-as="Thana" name="occupation.occThana"
                                :options="thanas.filter(occThana => occThana.district_id === occupation.occDistrict.id)"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    </template>
                    <span class="text-danger text-sm" v-show="errors.has('occupation.occThana')">{{ errors.first('occupation.occThana') }}</span>
                  </div>
                </div>
              </div>
              <div v-if="occupation.occThana" class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Office Area (অফিস অঞ্চল)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="occupation.officeArea" v-validate="'required'"
                              data-vv-as="Office Area" name="occupation.officeArea"/>
                    <span class="text-danger text-sm" v-show="errors.has('occupation.officeArea')">{{ errors.first('occupation.officeArea') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="occupation.officeArea" class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Apt#/House#/Road#/Village# (এ্যাপার্টমেন্ট/বাসা/সড়ক নং/গ্রাম )<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="occupation.ofcAptHouseRoadVill"
                              v-validate="'required'" data-vv-as="Apt#/House#/Road#/Village#"
                              name="occupation.ofcAptHouseRoadVill"/>
                    <span class="text-danger text-sm" v-show="errors.has('occupation.ofcAptHouseRoadVill')">{{ errors.first('occupation.ofcAptHouseRoadVill') }}</span>
                  </div>
                </div>
              </div>
              <div v-if="occupation.ofcAptHouseRoadVill" class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Postal code (ডাকঘর  নং)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" @keypress="onlyNumber"
                              v-model="occupation.ofcPostalCode" v-validate="'required|min:4|max:4'" data-vv-as="Postal code"
                              name="occupation.ofcPostalCode"/>
                    <span class="text-danger text-sm" v-show="errors.has('occupation.ofcPostalCode')">{{ errors.first('occupation.ofcPostalCode') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full text-right">
                <vs-button color="success" class="mr-3 mb-2 float-right" @click="updateOccupationInfoNoError(occupation)">Update
                </vs-button>
              </div>
            </div>
          </vx-card>
        </div>
      </form>
    </vx-card>
  </div>
</template>
<script>
  import division from '../../assets/utils/division'
  import district from '../../assets/utils/district'
  import upazila from '../../assets/utils/upazila'
  import vSelect from 'vue-select'
  import Datepicker from 'vuejs-datepicker'
  import axios from "../../axios";

  export default {
    data () {
      return {
        divisionJson: division.divisions,
        districtJson: district.districts,
        thanas: upazila.upazilas,
        userInfo: '',
        occupation: {
          id:'',
          occupationType: '',
          occupationName: '',
          monthlyIncome: '',
          officeOrBusinessNm: '',
          designation: '',
          year: '0',
          month: '0',
          jobLength: '',
          occAddressId:'',
          occDivision: '',
          occDistrict: '',
          occThana: '',
          officeArea: '',
          ofcAptHouseRoadVill: '',
          ofcPostalCode: ''
        },
        monthlyIncomeRange: ['1-10,000', '10,001-20,000', '20,001-30,000', '30,001-40,000', '40,001-50,000', '50,001-60,000', '60,001-70,000', '70,001-80,000', '80,001-90,000', '90,001-1,00,000', '1,00,001 +'],
        dependantDrop: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        jobLengthArr: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
        occupationDrop: ['Agricultural Firm', 'Audit Farm', 'Bank/Financial Organization', 'Consultancy Farm','Development/ Construction Farm', 'Educational Institution', 'Foreign Organization','Freelancer', 'Government Organization','Hospital/Health Care Organization','Hotel and Restaurant','Manufacturing Company','Multinational Company','Non-Government Organzation','Private Organization','Proprietorship Company','Public Limited Company','Telecom Industry','Tourism Industry','Other']
      }
    },
    mounted() {
      //this.$store.dispatch('apiLoading', true);
      axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/getApplicantOccupationInfo/`+this.$route.params.ekyc_id).then((response)=>{

        console.log("Occupation info = ", response);
        if (response.data.length > 0) {
          this.occupation.id = response.data[0].id
          this.occupation.occupationType = response.data[0].occupation_type
          this.occupation.occupationName = response.data[0].occupation
          this.occupation.monthlyIncome = response.data[0].monthly_income
          this.occupation.officeOrBusinessNm = response.data[0].name_of_Office_or_business
          this.occupation.designation = response.data[0].designation
          var ar = response.data[0].job_length.split(',')
          this.occupation.year = ar[0]
          this.occupation.month = ar[1]
          this.occupation.jobLength = this.occupation.year + ',' + this.occupation.month
          this.occupation.occAddressId = response.data[0].occupation_address.id
          this.occupation.occDivision = response.data[0].occupation_address.division
          this.occupation.occDistrict = response.data[0].occupation_address.district
          this.occupation.occThana = response.data[0].occupation_address.thana
          this.occupation.officeArea = response.data[0].occupation_address.office_area
          this.occupation.ofcAptHouseRoadVill = response.data[0].occupation_address.address
          this.occupation.ofcPostalCode = response.data[0].occupation_address.postal_code
        }
        this.$store.dispatch('apiLoading', false);
      });
      console.log("mounted", this.$route.params.ekyc_id)

    },
    methods: {
      updateOccupationInfoNoError (occupation) {
        return new Promise((resolve, reject) => {
          this.$validator.validateAll('occupation').then(result => {
            if (result) {
              this. updateOccupationInfo(occupation)
              resolve(true)
            } else {
              reject('correct all values')
            }
          })
        })
      },
      async updateOccupationInfo (occupation) {
        if(typeof occupation.occDivision === "object"){
          occupation.occDivision = occupation.occDivision.name;
        }
        if(typeof occupation.occDistrict === "object"){
          occupation.occDistrict = occupation.occDistrict.name;
        }
        if(typeof occupation.occThana === "object"){
          occupation.occThana = occupation.occThana.name;
        }
        console.log('UpdateOccu', occupation)
        axios.put(`https://ho.butterflygroupbd.com/showroom-backend/api/updateApplicantOccupationInfo`, occupation).then((data) => {
          console.log('Data = ', data)
          this.$vs.notify({
            title: 'Success',
            text: 'Occupation Information Successfully Updated.',
            color: 'success',
            position: 'top-right'
          });
          window.history.back();
        }).catch((error) => {
          console.log('Contact Error', error)
          this.$vs.notify({
            title: 'Error!',
            text: 'Something went wrong.',
            color: 'danger',
            position: 'top-right'
          })
        })
      },
      onlyNumber ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      },
      isLetter (e) {
        let char = String.fromCharCode(e.keyCode)
        if (/^[A-Za-z\' '\.]+$/.test(char)) return true
        else e.preventDefault()
      }
    },
    components: {
      //FormWizard,
      //TabContent,
      'v-select': vSelect,
      Datepicker
    }
  }
</script>
<style scoped>
  sup {
    font-size: 16px;
    color: red;
  }
</style>
